// orderProgressSlice.ts
import { OrderProgressUpdate } from "@/types/ApiTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


type OrderProgressState = {
  update: OrderProgressUpdate | null;
};

const initialState: OrderProgressState = {
  update: null,
};

const orderProgressSlice = createSlice({
  name: "orderProgress",
  initialState,
  reducers: {
    setOrderProgress: (state, action: PayloadAction<OrderProgressUpdate>) => {
      state.update = action.payload;
    },
    clearOrderProgress: (state) => {
      state.update = null;
    },
  },
});

export const { setOrderProgress, clearOrderProgress } = orderProgressSlice.actions;
export default orderProgressSlice.reducer;
